import { operationKindSchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod';
import { OperationPage } from '@/features/operations/operation-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/operations/nouvelle` — création d'une opération (`02` §10). Déclarée
 * **avant** `/operations/$id` dans `router.tsx` : sans cela, « nouvelle »
 * serait pris pour un identifiant. `?type=` porte le type choisi (absent =
 * produit offert).
 */
const operationNewSearchSchema = z.object({
  type: operationKindSchema.optional().catch(undefined),
});

function NewOperationRoute(): JSX.Element {
  return <OperationPage isNew />;
}

export const operationNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/operations/nouvelle',
  validateSearch: (search: Record<string, unknown>) => operationNewSearchSchema.parse(search),
  component: NewOperationRoute,
});
